import {combine, merge, Effect} from 'effector';

export const mergeEffects = <Params, Done, Fail = Error>(effects: Effect<Params, Done, Fail>[]) => {
    const done = merge(effects.map((fx) => fx.done));
    const doneData = merge(effects.map((fx) => fx.doneData));
    const fail = merge(effects.map((fx) => fx.fail));
    const failData = merge(effects.map((fx) => fx.failData));
    const finallyEvent = merge(effects.map((fx) => fx.finally));
    const $pending = combine(
        effects.map((fx) => fx.pending),
        (list) => list.some(Boolean),
    );

    return {done, doneData, fail, failData, finally: finallyEvent, $pending};
};
